module.exports = __webpack_public_path__ + "aaadbed5a2000237f378eab489388441.svg";


//////////////////
// WEBPACK FOOTER
// ./app/images/final-princess-mermaid.svg
// module id = 477
// module chunks = 0